<template>
  <div class="top">
    <div class="menagment-panel">
      <button
        class="btn btn-outline-dark"
        type="button"
        @click="changeStatus('ACCEPTED')"
      >
        Zaakceptuj zdjęcie
      </button>
      <button
        class="btn btn-outline-dark"
        type="button"
        @click="changeStatus('REJECTED')"
      >
        Odrzuć zdjęcie
      </button>
    </div>
    <table class="table borderless  ">
      <thead>
        <tr class="tr-table">
          <th scope="col">ID użytkownika</th>
          <th scope="col">Imię</th>
          <th scope="col">Nazwisko</th>
          <th scope="col">Zdjęcie</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user.id">
          <td>
            <input
              type="radio"
              :id="user.id"
              name="changeStatus"
              :value="user.id"
            />
            <label :for="user.id" style="margin:0px 0px 0px 5px;">{{
              user.id
            }}</label>
          </td>
          <td>{{ user.first_name }}</td>
          <td>{{ user.last_name }}</td>
          <td>
            <a
              target="_blank"
              :href="getUrl() + '/api/profile/photo/' + user.file_path"
            >
              <img
                :src="getUrl() + '/api/profile/photo/' + user.file_path"
                style="width: 50px; height: 50px"
              />
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import shared from "../shared";
import { URL } from "../axios";
export default {
  name: "unverifiedPhotos",
  computed: {
    users() {
      return this.$store.getters.getUsersWithUnverifiedPhotos;
    },
  },
  created() {
    this.$store.dispatch("getUsersWithUnverifiedPhotos");
    this.formattedDate = shared.formattedDate;
  },
  methods: {
    getUrl() {
      return URL;
    },
  },
};
</script>

<style scoped>
div {
  padding: 5px;
}
.menagment-panel i {
  font-size: 30px;
  cursor: pointer;
  margin: 5px;
  transform: translateY(7px);
}

.menagment-panel button {
  margin: 0px 5px;
}
</style>
